export default "__VITE_ASSET__f080360f__"